import { starsFor, type Bundle, type Lesson, type StageResult } from "@otto/lehrgang";
import { Stars } from "./Stars.js";
import styles from "./practice.module.css";
import own from "./LessonDone.module.css";

/** One row per stage with its stars and accuracy, then the way onwards. */
export function LessonDone({
  bundle,
  lesson,
  results,
  nextLesson,
  onRestart,
  onSwitchLesson,
  onBack,
}: {
  bundle: Bundle;
  lesson: Lesson;
  results: readonly StageResult[];
  nextLesson: Lesson | null;
  onRestart: () => void;
  onSwitchLesson?: ((lesson: Lesson) => void) | undefined;
  onBack: () => void;
}) {
  return (
    <div className={`${styles.card} ${own.done}`}>
      <h2 className={own.doneTitle}>Lektion {lesson.number} geschafft! 🎉</h2>

      <div className={own.resultList}>
        {results.map((result, i) => (
          <div key={result.stageKey} className={own.resultRow}>
            <span>{lesson.stages[i]?.title ?? result.stageKey}</span>
            <span className={own.resultStars}>
              <Stars count={starsFor(result.accuracy, bundle.starThresholds)} />
            </span>
            <span className={own.resultAccuracy}>
              {Math.round(result.accuracy * 100)}&nbsp;% genau
            </span>
          </div>
        ))}
      </div>

      {/* Der dritte Schritt von Heftseite 26. Ohne ihn geht das nächste Kind
          an ein Gerät, auf dem alles groß geschrieben wird. */}
      {lesson.uppercaseWith === "capsLock" && (
        <p className={own.capsReminder}>
          Denk dran: drück die Feststelltaste ⇪ wieder aus.
        </p>
      )}

      <div className={own.buttonRow}>
        <button type="button" className={styles.secondButton} onClick={onRestart}>
          Noch einmal üben
        </button>
        {nextLesson && onSwitchLesson ? (
          <button
            type="button"
            className={styles.startButton}
            onClick={() => onSwitchLesson(nextLesson)}
          >
            Weiter zu Lektion {nextLesson.number}
          </button>
        ) : (
          <button type="button" className={styles.startButton} onClick={onBack}>
            Zur Übersicht
          </button>
        )}
      </div>
    </div>
  );
}
